/* =========================================================================
 * Omni Dental Supply — 首页交互(干净重写, 不依赖 BigCommerce 平台代码)
 * 依赖: splide.min.js (轮播)
 * 还原: Hero 轮播 / 客户评价联动轮播 / 商品 Tabs / mega 菜单 /
 *       移动菜单 / 折叠菜单 / 购物车预览下拉 / sticky header
 * 后台对接 Shopify 时: 数据(商品/购物车/搜索)替换为 Liquid/AJAX 即可,
 *                      交互逻辑保持不变。
 * ========================================================================= */
(function () {
  'use strict';
  var MOBILE_BP = 800; // 与主题断点一致: <=800 视为移动端
  var mq = function () { return window.innerWidth <= MOBILE_BP; };

  document.addEventListener('DOMContentLoaded', init);

  function init() {
    initHeroCarousel();
    initReviewsCarousel();
    initGenericCarousels();
    initProductTabs();
    initScrollToTop();
    // header 交互(下拉/折叠/移动菜单/分类 mega/sticky)由 omni-header 自己的内嵌脚本驱动,
    // 这里不重复绑定,避免和 omni-header 双重处理冲突(class 互相覆盖)。
    // initDropdowns(); initCollapsibles(); initMobileMenu(); initCategorySubmenus(); initStickyHeader();
  }

  /* ---------- 8. 回到顶部浮动按钮(覆盖 .button 影响, 滚动显示) ---------- */
  function initScrollToTop() {
    var btn = document.getElementById('scrollToTopFloatingButton');
    if (!btn) return;
    btn.classList.remove('u-hiddenVisually'); // 取消无障碍隐藏, 由 is-visible + CSS 控制
    function onScroll() { btn.classList.toggle('is-visible', window.pageYOffset > 400); }
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- 1. Hero 轮播 ---------- */
  function initHeroCarousel() {
    var el = document.getElementById('heroCarousel');
    if (!el || typeof Splide === 'undefined') return;
    var slides = el.querySelectorAll('.splide__slide').length;
    var multi = slides > 1;
    new Splide(el, {
      type: multi ? 'loop' : 'fade',
      perPage: 1,
      arrows: multi,
      pagination: multi,
      drag: multi,
      autoplay: el.getAttribute('data-autoplay') === 'true',
      interval: 5000,
      speed: 600,
      pauseOnHover: true
    }).mount();
  }

  /* ---------- 2. 客户评价: 图片(main) + 文字(thumbs) 联动 fade ---------- */
  function initReviewsCarousel() {
    var main = document.getElementById('slider-main');
    var thumbs = document.getElementById('slider-thumbs');
    if (!main || !thumbs || typeof Splide === 'undefined') return;
    // 移除另存 DOM 里残留的旧 pagination/arrows, 避免与 Splide 重新生成的重复
    [main, thumbs].forEach(function (el) {
      el.querySelectorAll('.splide__pagination, .splide__arrows').forEach(function (n) { n.remove(); });
    });
    var mainSp = new Splide(main, {
      type: 'fade', rewind: true, pagination: false, arrows: false, drag: false
    });
    var thumbsSp = new Splide(thumbs, {
      type: 'fade', rewind: true, pagination: true, arrows: true, drag: false
    });
    mainSp.sync(thumbsSp);
    mainSp.mount();
    thumbsSp.mount();
  }

  /* ---------- 2b. 通用轮播(子页面: 多图商品轮播 + 其它未挂载 .splide) ---------- */
  function initGenericCarousels() {
    if (typeof Splide === 'undefined') return;
    var skip = { 'heroCarousel': 1, 'slider-main': 1, 'slider-thumbs': 1 };
    document.querySelectorAll('.splide').forEach(function (el) {
      if (skip[el.id]) return;                       // 首页 hero/评价已单独处理
      if (el.id && el.id.indexOf('pdp-gallery-') === 0) return; // PDP 图册由 section 内联脚本独占初始化
      if (el.classList.contains('is-initialized')) return;
      var multi = el.classList.contains('carousel-multi');
      new Splide(el, multi ? {
        // 参考站: 大屏(>1199)全显示无箭头, 中/小屏 slick 轮播带箭头
        type: 'slide', perPage: 5, perMove: 1, gap: '1.5rem', pagination: false,
        arrows: true, drag: true,
        breakpoints: { 1199: { perPage: 3 }, 767: { perPage: 2 }, 575: { perPage: 1 } }
      } : {
        type: 'loop', perPage: 1, arrows: true, pagination: true
      }).mount();
    });
  }

  /* ---------- 3. 商品 Tabs (Featured / Popular ...) ---------- */
  function initProductTabs() {
    document.querySelectorAll('[data-tab]').forEach(function (tabs) {
      var titles = tabs.querySelectorAll('.tab-title');
      titles.forEach(function (title) {
        title.addEventListener('click', function (e) {
          e.preventDefault();
          var targetId = title.getAttribute('aria-controls');
          var scope = tabs.closest('.emthemesModez-specialProductsTabs') || document;
          // 切换标题
          tabs.querySelectorAll('.tab').forEach(function (t) {
            t.classList.remove('is-active');
          });
          var li = title.closest('.tab');
          if (li) li.classList.add('is-active');
          title.setAttribute('aria-selected', 'true');
          // 切换面板
          scope.querySelectorAll('.tab-content').forEach(function (c) {
            c.classList.remove('is-active');
            c.setAttribute('aria-hidden', 'true');
          });
          var target = document.getElementById(targetId);
          if (target) {
            target.classList.add('is-active');
            target.setAttribute('aria-hidden', 'false');
          }
        });
      });
    });
  }

  /* ---------- 4. 下拉(购物车预览 / recently viewed) ---------- */
  function initDropdowns() {
    var openMenu = null;
    function closeAll() {
      document.querySelectorAll('[data-dropdown-content]').forEach(function (c) {
        c.setAttribute('aria-hidden', 'true');
        c.classList.remove('is-open');
      });
      openMenu = null;
    }
    // 初始全部收起
    document.querySelectorAll('[data-dropdown-content]').forEach(function (c) {
      c.setAttribute('aria-hidden', 'true');
    });
    document.querySelectorAll('[data-dropdown]').forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        var id = trigger.getAttribute('data-dropdown');
        var content = document.getElementById(id);
        if (!content) return;
        e.preventDefault();
        var willOpen = content.getAttribute('aria-hidden') === 'true';
        closeAll();
        if (willOpen) {
          content.setAttribute('aria-hidden', 'false');
          content.classList.add('is-open');
          openMenu = content;
        }
      });
    });
    document.addEventListener('click', function (e) {
      if (!openMenu) return;
      if (openMenu.contains(e.target)) return;
      if (e.target.closest('[data-dropdown]')) return;
      closeAll();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll();
    });
  }

  /* ---------- 5. 折叠菜单(断点感知) ----------
   * 本主题语义: data-collapsible-disabled-state="open"(桌面保持 is-open, 靠 CSS :hover 显隐)
   *            data-collapsible-enabled-state="closed"(移动端收起, 点击展开)
   * 所以: 桌面 -> 恢复 is-open(纯 hover, 不拦截点击/链接跳转)
   *       移动 -> 初始去 is-open, 点击切换 */
  function initCollapsibles() {
    var toggles = [].slice.call(document.querySelectorAll('[data-collapsible]'));

    function applyState() {
      var mobile = mq();
      toggles.forEach(function (toggle) {
        var content = document.getElementById(toggle.getAttribute('data-collapsible'));
        if (!content) return;
        if (mobile) {
          // 移动端: 收起(保留用户已展开的不强制, 仅初始化时收起)
          if (!toggle.hasAttribute('data-user-toggled')) {
            toggle.classList.remove('is-open');
            content.classList.remove('is-open');
            toggle.setAttribute('aria-expanded', 'false');
            content.setAttribute('aria-hidden', 'true');
          }
        } else {
          // 桌面: 恢复稳态 is-open, 交给 CSS hover 控制显隐
          toggle.classList.add('is-open');
          content.classList.add('is-open');
          toggle.removeAttribute('data-user-toggled');
        }
      });
    }

    toggles.forEach(function (toggle) {
      var content = document.getElementById(toggle.getAttribute('data-collapsible'));
      if (!content) return;
      toggle.addEventListener('click', function (e) {
        if (!mq()) return;                 // 桌面: 不拦截, 走 hover + 链接跳转
        e.preventDefault();
        toggle.setAttribute('data-user-toggled', '1');
        var open = toggle.classList.toggle('is-open');
        content.classList.toggle('is-open', open);
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        content.setAttribute('aria-hidden', open ? 'false' : 'true');
      });
    });

    applyState();
    var t;
    window.addEventListener('resize', function () {
      clearTimeout(t); t = setTimeout(applyState, 150);
    });
  }

  /* ---------- 6. 移动菜单开关 ---------- */
  function initMobileMenu() {
    var toggles = document.querySelectorAll('[data-mobile-menu-toggle]');
    toggles.forEach(function (toggle) {
      var id = toggle.getAttribute('data-mobile-menu-toggle');
      var menu = document.getElementById(id);
      if (!menu) return;
      toggle.addEventListener('click', function (e) {
        e.preventDefault();
        var open = toggle.getAttribute('aria-expanded') !== 'true';
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        toggle.classList.toggle('is-open', open);
        menu.setAttribute('aria-hidden', open ? 'false' : 'true');
        menu.classList.toggle('is-open', open);
        document.body.classList.toggle('has-activeNavPages', open);
        document.body.classList.toggle('navPages-open', open);
      });
    });
  }

  /* ---------- 6.5 桌面 mega 菜单里 Categories 的子分类展开 ----------
   * 行为: 在 .navPages-list--categories 里
   *   - 点击 .container-has-sublink 整体(箭头/空白处) -> 给它加 soft-blue,
   *     给同级 li 下的 .navPage-subMenu 加 custom-open(CSS 让三级菜单浮出)
   *   - 再次点击切换关闭; 同一列表内互斥(展开一个会关掉其它)
   *   - 第四级: 点击 .container-sublink-level2 整体 -> 给紧邻的 .navPage-childList
   *     加 custom-open-level2; 同一三级菜单内互斥
   *   - 内部的 <a class="navPages-action has-subMenu"> 链接照常点击跳转分类页:
   *     点到 <a> 时直接放行, 不 preventDefault, 不触发展开
   * 仅桌面(>800)生效; 移动端折叠交给 initCollapsibles 处理 */
  function initCategorySubmenus() {
    var lists = [].slice.call(document.querySelectorAll('.navPages-list--categories'));
    lists.forEach(function (list) {
      list.addEventListener('click', function (e) {
        if (mq()) return;                       // 仅桌面 mega 菜单
        var t = e.target;
        if (!t || !t.closest) return;
        var link = t.closest('a');              // 点到链接 -> 放行跳转

        // 第四级: 点击 .container-sublink-level2 整体
        var box2 = t.closest('.container-sublink-level2');
        if (box2 && list.contains(box2)) {
          if (link && box2.contains(link)) return;
          e.preventDefault();
          var child = box2.parentElement.querySelector('.navPage-childList');
          if (!child) return;
          var open2 = !child.classList.contains('custom-open-level2');
          var sub2 = box2.closest('.navPage-subMenu');
          if (sub2) {
            sub2.querySelectorAll('.navPage-childList.custom-open-level2')
              .forEach(function (c) { c.classList.remove('custom-open-level2'); });
          }
          if (open2) child.classList.add('custom-open-level2');
          return;
        }

        // 第三级: 点击 .container-has-sublink 整体
        var box = t.closest('.container-has-sublink');
        if (box && list.contains(box)) {
          if (link && box.contains(link)) return;
          e.preventDefault();
          var li = box.closest('.navPages-item');
          var sub = li && li.querySelector('.navPage-subMenu');
          if (!sub) return;
          var open = !sub.classList.contains('custom-open');
          // 互斥: 关掉本列表内其它已展开的三级菜单(及其下第四级)
          list.querySelectorAll('.container-has-sublink.soft-blue')
            .forEach(function (c) { c.classList.remove('soft-blue'); });
          list.querySelectorAll('.navPage-subMenu.custom-open')
            .forEach(function (s) {
              s.classList.remove('custom-open');
              s.querySelectorAll('.navPage-childList.custom-open-level2')
                .forEach(function (c) { c.classList.remove('custom-open-level2'); });
            });
          if (open) {
            box.classList.add('soft-blue');
            sub.classList.add('custom-open');
          }
        }
      });
    });
  }

  /* ---------- 7. sticky header ----------
   * 主题机制: 滚动后给 <header.header> 加 is-sticky
   *   -> CSS: .header.is-sticky{position:fixed;z-index:50} 且隐藏顶部副栏 */
  function initStickyHeader() {
    var header = document.querySelector('header.header') || document.querySelector('.header');
    if (!header) return;
    // 用 placeholder 占位避免 fixed 后内容跳动
    var trigger = 120; // 滚过多少像素后固定
    function onScroll() {
      // 中屏(<=800)不做 sticky: 移动端 header 不固定
      var stuck = !mq() && window.pageYOffset > trigger;
      if (stuck === header.classList.contains('is-sticky')) return;
      header.classList.toggle('is-sticky', stuck);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    // 断点切换时(如缩放过 800)重新评估, 避免移动端残留 is-sticky
    window.addEventListener('resize', onScroll, { passive: true });
    onScroll();
  }
})();
